








import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Input extends Vue {
  @Prop() private value?: any;
  @Prop({ default: 'text' }) private readonly type?: string;
  @Prop() private readonly name?: string;
  @Prop() private readonly id?: string;
  @Prop() private readonly placeholder?: string;
  @Prop({ default: true }) private readonly required?: boolean;
  @Prop({ default: false }) private readonly disabled?: boolean;
  @Prop({ default: false }) private readonly readonly?: boolean;
  @Prop() private readonly loading?: boolean | string;
  @Prop({ default: 'primary' }) private readonly color?: string;
  @Prop() private readonly mask?: string | [];
  @Prop({ default: false }) private readonly error?: boolean;
  @Prop({ default: 1 }) private readonly errorCount?: number | string;
  @Prop() private readonly errorMessages?: [];
  @Prop() private readonly appendIcon?: string;
  @Prop() private readonly maxlength?: string;
  @Prop() private readonly pattern?: string;
  @Prop() private readonly inputmode?: string;
  @Prop() private readonly 'return-masked-value'?: boolean;

  private data = this.value;
  public $refs!: {
    input: HTMLElement;
  };

  input(value: any) {
    this.$emit('input', value);
  }

  get listeners() {
    return { ...this.$listeners, input: this.input };
  }

  focus() {
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  }
}
